

import Vue from 'vue';
import * as GlossStore from '@/store/search/form/glossStore';
import SelectPicker from '@/components/SelectPicker.vue'

export default Vue.extend ({
	name: 'GlossField',
	components: {
		SelectPicker
	},
	props: {
		fieldDescription: Object as () => GlossStore.GlossFieldDescription,
		fieldName: String,
		hitId : String,
		hit_first_word_id: String,
		hit_last_word_id: String
	},
	computed : {
		currentValue: {
			get(): string { return GlossStore.get.getGlossValue(this.hitId, this.fieldName) },
			set(v: string) {
				GlossStore.actions.setOneGlossField({
					hitId: this.hitId,
					fieldName: this.fieldName,
					fieldValue: v,
					hit_first_word_id: this.hit_first_word_id,
					hit_last_word_id: this. hit_last_word_id
				})
			}
		}
	},
})

